/**
 * Created by: Arnaldas Augutis
 * Date: 04/08/16
 * Time: 14:21
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const get = require('lodash.get');
const css = require('./payment-methods.scss');
const paymentMethodsConstants = require('../../constants/paymentMethodsConstants.json');

const creditCardIcons = {
    visa: require('dibs-vg/dist/react/payment-visa'),
    discover: require('dibs-vg/dist/react/payment-discover'),
    americanExpress: require('dibs-vg/dist/react/payment-american-express'),
    masterCard: require('dibs-vg/dist/react/payment-mastercard'),
    wireTransfer: require('dibs-vg/dist/react/payment-wire-transfer'),
    paypal: require('dibs-vg/dist/react/payment-paypal'),
    check: require('dibs-vg/dist/react/payment-check')
};

const _getBestPrice = (prices, canSeeNetPrice) => {
    let bestPrice;
    prices.forEach(priceNode => {
        const price = get(priceNode, 'amount.convertedAmounts.USD');

        // NET price is set even if user can't see it
        if (priceNode.type === 'NET' && !canSeeNetPrice) {
            return false;
        }
        if (!bestPrice || bestPrice > price) {
            bestPrice = price;
        }
        return false;
    });
    return bestPrice;
};

const _getCard = (name) => {
    const CardComponent = creditCardIcons[name];
    if (CardComponent) {
        return <CardComponent className={css.creditCardIcon} key={name}/>;
    } else {
        return null;
    }
};

const _getCreditCardsEl = () => {
    return paymentMethodsConstants.cards.map(card => {
        return _getCard(card.icon);
    });
};

const _getWireTransfer = (user) => {
    user = user || {};
    if (user.isVerifiedTrade || user.isVip) {
        return _getCard('wireTransfer');
    }
    return null;
};

const _getCheck = (user) => {
    return get(user, 'canCheckoutWithCheck') ? _getCard('check') : null;
};

const _getPaypalEl = (price) => {
    // PayPals is available for <55000 price
    if (price && price < paymentMethodsConstants.paypalPriceThreshold) {
        return _getCard('paypal');
    }
    return null;
};

const DetailsPaymentMethods = (props) => {
    const { item, user } = props;
    const canSeeNetPrice = user ? user.canSeeNetPrice : false;
    const prices = get(item, 'pricing.prices', []);
    const bestPrice = _getBestPrice(prices, canSeeNetPrice);

    return (
        <div className="pdp-details-entry-content-container pdp-payment-methods-wrapper">
            <div className="pdp-details-entry-title-container">
                <span className="pdp-details-entry-title">{paymentMethodsConstants.title}</span>
            </div>
            <div className="pdp-details-entry-content">
                <p>{paymentMethodsConstants.description}</p>
            </div>
            <div className="pdp-details-payment-methods-icons-wrapper">
                {_getCreditCardsEl()}
                {_getPaypalEl(bestPrice)}
                {_getWireTransfer(user)}
                {_getCheck(user)}
            </div>
        </div>
    );
};

DetailsPaymentMethods.propTypes = {
    item: PropTypes.object,
    user: PropTypes.object
};

module.exports = Relay.createContainer(DetailsPaymentMethods, {
    fragments: {
        item: () => Relay.QL`
            fragment on Item {
                pricing {
                    prices {
                      type
                      amount {
                        convertedAmounts {
                          USD
                        }
                      }
                    }
                }
            }
        `,
        user: () => Relay.QL`
            fragment on User {
                canSeeNetPrice: hasPermission(name: "B_NET_PRICE")
                canCheckoutWithCheck: hasPermission(name: "B_CHECKOUT_CHECK")
                isVerifiedTrade
                isVip
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsPaymentMethods.jsx